export default __webpack_public_path__ + "static/media/Minus.c8be1072.svg";